import React from 'react';
import {search} from '../assets/images/images';
import {debounceFunction} from '../helpers';

export default function SearchInput({
  onChange,
  placeholder,
  defaultValue,
  className = '',
  disabled = false,
}) {
  const debounceChange = debounceFunction(e => {
    onChange(e.target.value);
  }, 1000);

  return (
    <label htmlFor="search" className="relative label flex-wrap items-center">
      <input
        type="search"
        name="search"
        placeholder={placeholder || 'Search'}
        className={`input max-w-full w-full sm:w-[425px] placeholder:text-tiny ${className}`}
        onChange={debounceChange}
        defaultValue={defaultValue}
        disabled={disabled}
      />
      <img
        src={search}
        alt=""
        className="absolute left-[13px] top-[9px]"
        width={16}
        height={16}
      />
    </label>
  );
}
